import React from 'react';

import ForgotPasswordForm from '../components/ForgotPasswordForm';

export default function Login() {
  return <ForgotPasswordForm />;
}
